export default "__VITE_ASSET__D095es_e__"